import {
  getAnalytics,
  setUserId as firebaseSetUserId,
  setUserProperties as firebaseSetUserProperties,
  logEvent as firebaseLogEvent,
} from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import {
  fetchAndActivate,
  getValue as firebaseGetValue,
  getRemoteConfig,
} from 'firebase/remote-config';

import featureFlags from '@src/constants/featureFlags';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}appspot.com`,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const Firebase =
  featureFlags.features.activityTracker() && initializeApp(firebaseConfig);

// Analytics
const analytics = Firebase && getAnalytics(Firebase);

export const setUserId = (id: string) =>
  analytics && firebaseSetUserId(analytics, id);
export const setUserProperties = (properties: {
  [key: string]: string | number | boolean | null | undefined;
}) => analytics && firebaseSetUserProperties(analytics, properties);
export const logEvent = (
  eventName: string,
  eventParams?: { [key: string]: string | number | boolean | null | undefined },
) => analytics && firebaseLogEvent(analytics, eventName, eventParams);

// Remote Config
const remoteConfig = Firebase && getRemoteConfig(Firebase);

if (remoteConfig && import.meta.env.VITE_ENV !== 'production') {
  remoteConfig.settings.minimumFetchIntervalMillis = 1000;
  fetchAndActivate(remoteConfig);
}

export const getValue = (key: string) => {
  if (!remoteConfig) return null;

  return firebaseGetValue(remoteConfig, key);
};

export default Firebase;
